module.exports = __webpack_public_path__ + "static/media/click1.8befe78b.aac";